import { MerchState } from './state';

export const merchInitialState: MerchState = {
  catalog: [],
  artistMerch: [],
  loaded: false,
  isNewMerch: true,
  artistMerchCount: 0,
};
